import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { userActivationAsync, resendUserActivationAsync } from '../app/userSlice'
import { UrlParams } from '../utils/commonHelper'

export const UserActivation = ({ history, location }) => {
    const dispatch = useDispatch()

    const activationDetails = useSelector(state => state.user.activationDetails);

    useEffect(() => {
        const params = new UrlParams(location.search);
        if (params.get('username')) {
            /* If email and token exists in URL params, use that */
            dispatch(userActivationAsync(params.get('username'), `${params.get('token')}=`, history));
        } else if (activationDetails['email']) {
            /* If email and token exists in redux state, use that */
            dispatch(resendUserActivationAsync(activationDetails.email, activationDetails.token, history))
        } 
        else {
           // history.push('/status/activationsuccess');
            history.push('/');
        }

    }, [dispatch, history, location, activationDetails]);

    return null
}